// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title[data-v-870a0d6c]:not(:focus)\n{ \n  border: none;\n  outline: none;\n  box-shadow: none;\n  font-weight: bold;\n  background: lightgray;\n}\n", ""]);
// Exports
module.exports = exports;
